import { render, staticRenderFns } from "./FirmeDostava.vue?vue&type=template&id=7ec4ab80&scoped=true"
import script from "./FirmeDostava.vue?vue&type=script&lang=js"
export * from "./FirmeDostava.vue?vue&type=script&lang=js"
import style0 from "./FirmeDostava.vue?vue&type=style&index=0&id=7ec4ab80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec4ab80",
  null
  
)

export default component.exports